<template>
    <v-flex xs8 offset-xs2 sm6 offset-sm3 lg4 offset-lg4 class="pa-2">
        <v-card>
            <v-form ref="form" lazy-validation @keyup.native.enter="validate">
                <v-card-title class="display-1 font-weight-light" primary-title>
                    Connexion
                </v-card-title>

                <v-card-text>
                    <v-text-field ref="inputName" v-model="formUsername" xs6 sm3 md2 lg1 label="Login" required :rules="[rules.required]"></v-text-field>
                    <v-text-field v-model="formPassword" append-icon="visibility_off" :rules="[rules.required]" type="password" label="Mot de passe"></v-text-field>

                    <v-card-text v-if="formError" class="red--text">{{ formError }}</v-card-text>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="green lighten-2 white--text" :disabled="loading" @click="validate">
                        Connexion
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-flex>
</template>

<script>
    import {SECURITY_FETCH_USER, SECURITY_REQUEST_TOKEN, SECURITY_STORE_TARGET_URL} from "../../store/actions.type";
    import {AuthenticationService} from "../../services/authentication.service";
    import {mapGetters} from "vuex";

    export default {
        name: "LoginForm",
        data: () => ({
            dialog: false,
            formError: '',
            formUsername: '',
            formPassword: '',
            loading: false,
            rules: {
                required: value => !!value || 'Champ requis',
            }
        }),
        computed: {
            ...mapGetters(["targetURL"])
        },
        mounted() {
            AuthenticationService.clear();
        },
        methods: {
            /**
             * Soumission du formulaire pour obtenir un token
             */
            validate() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    let payload = {
                        username: this.formUsername,
                        password: this.formPassword,
                    };

                    this.$store.dispatch(SECURITY_REQUEST_TOKEN, payload)
                        .then(() => {
                            if (this.targetURL) {
                                this.$router.push(this.targetURL);
                                this.$store.dispatch(SECURITY_STORE_TARGET_URL, null);
                            } else {
                                this.$router.push({name: 'directory-show'});
                            }

                            this.$store.dispatch(SECURITY_FETCH_USER);
                        })
                        .catch(() => {
                            this.formError = 'Identifiants incorrects';
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
        }
    };
</script>

<style scoped lang="scss">
</style>
